const installationInstructions = {
  intro: {
    currentStep: 'intro',
    headerIcon: 'arrowGrey',
    includeInstallationSteps: false,
    includePairingProcess: false,
    isLastPage: false,
    nextStep: 'powerOnCamera',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: 'Congratulations on getting a Cori camera!',
    haloDeviceResource: require('@/assets/device-models/MOCAM-SIG02/Cori_halo.png'),
    resource: require('@/assets/device-models/MOCAM-SIG02/hik-cori-cam.png'),
    resourceType: 'image',
    secondaryText: 'Let\'s get started with pairing your new camera.',
    continueButtonText: 'Start pairing',
  },
  powerOnCamera: {
    currentStep: 'powerOnCamera',
    headerIcon: 'arrowGrey',
    prevStepName: 'installationIntro',
    isLastPage: false,
    resourceType: 'image',
    resource: require('@/assets/device-models/MOCAM-SIG02/Cori_Plug.png'),
    primaryText: 'Power on your camera',
    secondaryText: 'After you have assembled your Cori, plug it in using the supplied power adapter. The light on the front of your camera will turn on when the camera is on.',
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
  },
  letsGetStarted: {
    currentStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStep: 'powerOnCamera',
    prevStepName: 'instructions',
    resourceType: 'video',
    resource: require('@/assets/device-models/MOCAM-SIG02/Cori_Pairing-Mode_Light.mp4'),
    poster: require('@/assets/device-models/MOCAM-SIG02/Cori_Pairing-Mode_Light_poster.png'),
    videoType: 'video/mp4',
    videoAutoPlay: 'autoplay',
    videoLoop: 'loop',
    videoControls: false,
    primaryText: 'Verify device is in pairing mode',
    secondaryText: 'It may take a few minutes after powering on the camera before it is in pairing mode. Ways to verify:',
    steps: [
      {
        title: 'Voice confirmation',
        description: 'You will hear a voice confirmation from the camera when it is ready to pair.',
        stepNumber: 1
      },
      {
        title: 'Blinking light pattern',
        description: 'The light will also turn to a double blinking blue.',
        stepNumber: 2
      },
    ],
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      title: 'Read instructions',
    },
    continueButtonText: 'Ready',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  },
  pairingModeReset: {
    prevStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/MOCAM-SIG02/Momentum_Cori_Pairing-Mode.png'),
    primaryText: 'Putting Cori into Pairing Mode',
    secondaryText: 'If the light on the front of the camera is not double blinking blue, it is not in pairing mode. To manually put the Cori into pairing mode:',
    steps: [
      {
        title: 'Press and hold',
        description: 'Press and hold the button on the back of your camera',
        stepNumber: 1
      },
      {
        title: 'Release',
        description: 'Release the button as soon as you see the light on the front of the camera turn solid red.',
        stepNumber: 2
      },
      {
        title: 'Voice confirmation',
        description: 'After the Cori finishes restarting, you will hear a voice confirmation indicating the camera is ready to pair. The light on the front of the camera will turn to double blinking blue.',
        stepNumber: 3
      },
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  }
};

export default installationInstructions;
